/*
 * Pipeline Theme — Kite free-gift ↔ cart drawer sync
 *
 * After cart mutations, Kite may add/remove a gift asynchronously. The drawer
 * AJAX render often finishes first. This script polls /cart.js (debounced,
 * coalesced) while the drawer is open and triggers a single theme:cart:reload
 * when the line-item snapshot changes — without nesting reload storms.
 */
(function () {
  var POLL_MS = [550, 1200];
  var COOLDOWN_MS = 400;
  var timers = [];
  var lastSnapshot = '';
  var syncing = false;
  var cooldown = false;

  function drawerEl() {
    return document.querySelector('[data-drawer="drawer-cart"]');
  }

  function isDrawerOpen() {
    var drawer = drawerEl();
    if (!drawer) return false;
    if (window.theme && window.theme.state && window.theme.state.cartOpen) return true;
    return drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.classList.contains('is-open');
  }

  function cartSnapshot(cart) {
    if (!cart || !cart.items) return '';
    return String(cart.item_count) + ':' + cart.items.map(function (item) {
      return String(item.key || item.id) + 'x' + String(item.quantity);
    }).join('|');
  }

  function clearTimers() {
    timers.forEach(function (id) {
      clearTimeout(id);
    });
    timers = [];
  }

  function pollAndSync() {
    if (syncing || cooldown) return;
    if (!isDrawerOpen()) return;
    if (!window.theme || !window.theme.routes || !window.theme.routes.cart) return;

    syncing = true;
    window.fetch(window.theme.routes.cart + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error(response.statusText || 'cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        var snapshot = cartSnapshot(cart);
        if (!snapshot || snapshot === lastSnapshot) return;

        lastSnapshot = snapshot;
        cooldown = true;

        // Push fresh cart into CartItems, then request one HTML refresh
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {
          bubbles: true
        }));

        setTimeout(function () {
          cooldown = false;
        }, COOLDOWN_MS);
      })
      .catch(function () {
        // Non-fatal — theme cart flow continues without Kite follow-up
      })
      .then(function () {
        syncing = false;
      });
  }

  function queueSync() {
    if (!isDrawerOpen()) return;
    clearTimers();
    POLL_MS.forEach(function (ms) {
      timers.push(setTimeout(pollAndSync, ms));
    });
  }

  document.addEventListener('theme:cart:change', function (event) {
    // Ignore the change event we dispatch ourselves during sync
    if (syncing) return;
    var cart = event && event.detail && event.detail.cart;
    if (cart) {
      // Baseline from theme; still poll in case Kite mutates after this event
      var snap = cartSnapshot(cart);
      if (snap && !lastSnapshot) {
        lastSnapshot = snap;
      }
    }
    queueSync();
  });

  document.addEventListener('theme:drawer:open', function (event) {
    var target = event && event.target;
    if (!target || !target.matches || !target.matches('[data-drawer="drawer-cart"]')) {
      return;
    }
    // Allow a post-open Kite mutation to differ from whatever was last rendered
    queueSync();
  }, true);
})();
